module.exports = __webpack_public_path__ + "img/xxm.3de4f24c.svg";